'use client'
import { cn } from '@/lib/utils'
import {
  useCurrency,
  useLocale,
  withCurrencyProviderSuspense,
} from '@/components/context-providers/currency-context'

interface MonetaryValueProps {
  value: any
  className?: string
}

const MonetaryValue = ({ value, className }: MonetaryValueProps) => {
  const numericValue = Number.parseFloat(value)
  const currency = useCurrency()
  const lang = useLocale()

  const locale = lang === 'de' ? 'de-CH' : lang

  return (
    <span className={cn('whitespace-nowrap', className)}>
      {`${
        Number.isNaN(numericValue)
          ? '-'
          : new Intl.NumberFormat(locale, {
              style: 'currency',
              currency,
              minimumFractionDigits: 2,
            }).format(numericValue)
      }`}
    </span>
  )
}

export default withCurrencyProviderSuspense(MonetaryValue)
